exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-58e5c078]{padding-bottom:0;margin-bottom:10px}\n", ""]);

// exports
